import { styled } from '@mui/material/styles';

export const EditPalletParametersDialogStyledContainer = styled('div')`
  position: relative;
  text-align: center;
  padding: 16px;
  gap: 15px;

  .MuiTypography-h2 {
    font-size: 26px;
  }

  .cargo-inputs-block {
    display: flex;
    flex-wrap: wrap;
    gap: 13px 22px;
    margin: 24px 0;

    > .MuiTextField-root {
      flex: 1;
      min-width: clamp(80px, calc(100% / 3 - 60px), 100%);
    }

    .MuiSelect-icon {
      font-size: 18px !important;
      fill: #383838;
    }

    .MuiInput-input {
      color: rgb(56, 56, 56) !important;
      text-align: right !important;
      font-size: 12px !important;
      font-style: normal !important;
      font-weight: 600 !important;
      line-height: 22px !important;
      padding: 4px 5px;
    }

    .MuiSelect-select {
      padding-right: 24px;
    }
  }

  .pallet-edit-control {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }

  .pallet-edit-button {
    color: #fff;
    font-weight: 600;
  }
`;
